import { IDownloaderResponse } from '../../Downloader';

export interface IHttpResponse {
  status?: number;
  body?: any;
  message?: string;
  detail?: any;
}

export async function handleSuccess(
  response: IDownloaderResponse
): Promise<IHttpResponse> {
  return {
    status: response?.status,
    body: response?.body,
  };
}

export async function handleError({
  response,
  request,
  message,
}: {
  response: IDownloaderResponse;
  request: unknown;
  message: string;
}): Promise<IHttpResponse> {
  if (response) {
    return {
      status: response.status,
      message: response.data?.errors?.[0]?.detail,
    };
  }

  if (request) {
    return {
      body: request,
    };
  }

  return {
    message,
  };
}
